import {useContext, useMemo} from "react";

import type {ListingGroup} from "../../../models/listingGroup";
import {UserContext} from "../../contexts";

function useListingGroup(listingID: string | undefined): ListingGroup | undefined;
function useListingGroup(listingID: string[] | undefined): ListingGroup[] | undefined;
function useListingGroup(
    listingID: string[] | string | undefined
): ListingGroup | ListingGroup[] | undefined {
    const {listingGroups} = useContext(UserContext);

    return useMemo(() => {
        if (!listingID) {
            return;
        }

        if (typeof listingID === "string") {
            return listingGroups.find(elem => elem._id === listingID);
        }

        return listingGroups.filter(elem => {
            return Array.isArray(listingID) ? listingID.includes(elem._id) : listingID === elem._id;
        });
    }, [listingID, listingGroups]);
}

export {useListingGroup};
